import { defineComponent as _defineComponent } from 'vue'
import BuyBoxRow from '@/components/buybox/BuyBoxRow.vue';
import BuyBoxFastOffer from '@/components/buybox/BuyBoxFastOffer.vue';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { FastOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';

interface FastRowProps {
	title: TitleDetail;
	offers: FastOfferFragment[];
	inline?: boolean;
	trackingContexts?: SnowplowContext[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxFastRow',
  props: {
    title: null,
    offers: null,
    inline: { type: Boolean },
    trackingContexts: { default: () => [] }
  },
  emits: ["clickOut"],
  setup(__props: any) {





return { __sfc: true,BuyBoxRow, BuyBoxFastOffer }
}

})